// @flow
import React, { PureComponent } from 'react';
import { StyleSheet, View } from 'react-native';
import { Text } from 'trpc-react-native-ui';
import I18n from '../../lib/i18n';
import type { NavigationScreenProp } from '@react-navigation/compat';

export default class GetRioNumber extends PureComponent<Props> {
  styles = getStyles();
  render() {
    return (
      <View style={this.styles.content}>
        <Text style={this.styles.text}>{I18n.t('Dashboard.GetRioNumber.yourRio')}</Text>
        <Text style={this.styles.rio}>{this.props.route.params?.rio ?? ''}</Text>
      </View>
    );
  }
}

type Props = NavigationScreenProp;

const getStyles = () =>
  StyleSheet.create({
    content: {
      alignItems: 'center',
    },
    rio: {
      fontSize: 20,
      fontWeight: '600',
    },
    text: {
      fontSize: 20,
      marginBottom: 50,
      marginTop: 50,
    },
  });
